import { merge } from "lodash";

import {
  DashboardActions,
  DashboardActionTypes,
  DashboardState,
} from "./dashboardTypes";

const initialState: DashboardState = {
  group: {
    whole: {
      avgCheckoutPrice: 0,
      totalCheckoutPrice: 0,
      totalDepositPoint: 0,
      totalMemberCount: 0,
      totalOrderCount: 0,
      updatedAt: "",
    },
    period: {
      totalCheckoutPrice: 0,
      totalMemberCount: 0,
      totalOrderCount: 0,
    },
  },
  store: {
    whole: {
      avgCheckoutPrice: 0,
      totalCheckoutPrice: 0,
      totalDepositPoint: 0,
      totalMemberCount: 0,
      totalOrderCount: 0,
      updatedAt: "",
    },
    period: {
      avgCheckoutPrice: 0,
      resources: [],
      totalCheckoutPrice: 0,
      totalCheckoutPriceByDepositPoint: 0,
      totalOrderCount: 0,
    },
  },
};

const dashboardReducer = (
  state = initialState,
  actions: DashboardActions
): DashboardState => {
  switch (actions.type) {
    case DashboardActionTypes.GET_CURRENT_GROUP_SUMMARY:
      return {
        ...state,
        group: merge<
          {},
          DashboardState["group"],
          Partial<DashboardState["group"]>
        >({}, state.group, { whole: actions.payload }),
      };
    case DashboardActionTypes.GET_CURRENT_STORE_SUMMARY:
      return {
        ...state,
        store: merge<
          {},
          DashboardState["store"],
          Partial<DashboardState["store"]>
        >({}, state.store, { whole: actions.payload }),
      };
    case DashboardActionTypes.POST_TO_SEARCH_GROUP_PEROID_SUMMARY:
      return {
        ...state,
        group: merge<
          {},
          DashboardState["group"],
          Partial<DashboardState["group"]>
        >({}, state.group, { period: actions.payload }),
      };
    case DashboardActionTypes.POST_TO_SEARCH_STORE_PEROID_SUMMARY:
      return {
        ...state,
        store: {
          ...state.store,
          period: {
            ...actions.payload,
          },
        },
      };
    default:
      return state;
  }
};

export default dashboardReducer;
